import React from 'react';
import Page from '../componets/page';
import { useAppSelector } from '../store/hooks';
import { selectUserProfile } from '../store/slices/authSlice';
import { UserTypes } from '../constants';

export function RequireAro({ children }) {
    const userProfile = useAppSelector(selectUserProfile);

    if (userProfile === UserTypes.aro) {
        return children;
    }
    return (
        <Page>
            <div className="px-4 pt-4">This page is not available.</div>
        </Page>
    );
}
